module.exports = __webpack_public_path__ + "static/media/scrolls.7bcbb388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scrolls.jpg
// module id = 137
// module chunks = 0